import { thermo_standard_vert } from './thermo-standard-vert'
import { thermo_standard_frag } from './thermo-standard-frag'
import { MeshStandardMaterial, MeshStandardMaterialParameters, Vector2, Color, UniformsUtils, ShaderLib, Matrix4, Texture, Vector3, Scene } from 'three';


class ThermoStandardMaterial extends MeshStandardMaterial {
    
    constructor (parameters, customUniforms, defines) {
        super(parameters);
        this.userData.texture1 = {value: null};
		this.userData.texture2 = {value: null};

        const vertProgram = thermo_standard_vert;
        const fragProgram = thermo_standard_frag;

        this.uniforms = UniformsUtils.merge( [
            ShaderLib.physical.uniforms,
            {
                texture1: {value: null},
				texture2: {value: null},
            }
        ]);

        this.onBeforeCompile = ( shader ) => {
            shader.uniforms.texture1 = this.userData.texture1;
			shader.uniforms.texture2 = this.userData.texture2;
            shader.vertexShader = vertProgram;
            shader.fragmentShader = fragProgram;
        };

        // for(var k = 0 ; k < defines.length; k++){
        //     this.defines[defines[k]] = "";
        // }
    }

}

export default ThermoStandardMaterial